




import { Component, Vue } from "vue-property-decorator";
import * as Firebase from "firebase/app";
import * as firebase from "@/firebase";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

@Component
export default class LoginWidget extends Vue {
  mounted() {
    const uiConfig = {
      signInFlow: "popup",
      callbacks: {
        signInSuccessWithAuthResult() {
          return false;
        },
      },
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        Firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
      ],
      // tosUrl and privacyPolicyUrl accept either url string or a callback
      // function.
      // Terms of service url/callback.
      tosUrl: () => {
        this.$router.push({ name: "Tos" });
      },
      // Privacy policy url/callback.
      privacyPolicyUrl: () => {
        this.$router.push({ name: "Privacy" });
      },
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      const auth = firebase.auth;
      ui = new firebaseui.auth.AuthUI(auth);
    }
    ui.start("#firebaseui-auth-container", uiConfig);
  }
}
